import { render, staticRenderFns } from "./CancelNotification.vue?vue&type=template&id=f83e1196&"
import script from "./CancelNotification.vue?vue&type=script&lang=js&"
export * from "./CancelNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports